<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Submitted Migrations</h4>
            <div class="row">
              <div class="col-md-10">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a
                        class="nav-link active show"
                        id="active-tab"
                        data-toggle="tab"
                        href="#activeMigrations"
                        role="tab"
                        aria-controls="up"
                        @click="switchTab('activeMigrations')"
                    >Active</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="review-tab"
                        data-toggle="tab"
                        href="#reviewMigrations"
                        role="tab"
                        aria-controls="down"
                        @click="switchTab('reviewMigrations')"
                    >Review</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="resolved-tab"
                        data-toggle="tab"
                        href="#resolveMigrations"
                        role="tab"
                        aria-controls="down"
                        @click="switchTab('resolveMigrations')"
                    >Finished</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="abandoned-tab"
                        data-toggle="tab"
                        href="#abandonedMigrations"
                        role="tab"
                        aria-controls="down"
                        @click="switchTab('abandonedMigrations')"
                    >Abandoned</a
                    >
                  </li>
                </ul>
              </div>
              <div class="col-md-2 align-bottom">
                <button
                    class="btn btn-primary btn-block"
                    data-toggle="modal"
                    data-target="#update-checklist-modal"
                >
                  Checklist
                </button>
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 0 !important">
            <div class="tab-content customer-table">
              <div id="activeMigrations" class="tab-pane active show" v-if="selectedTab === 'activeMigrations'">
                <TaskList
                    ref="pendingTasks"
                    :tasks="activeMigrations"
                    type="active"
                />
              </div>
              <div id="reviewMigrations" class="tab-pane fade" v-if="selectedTab === 'reviewMigrations'">
                <TaskList
                    ref="reviewTasks"
                    :tasks="reviewMigrations"
                    type="review"
                />
              </div>
              <div id="resolveMigrations" class="tab-pane fade" v-if="selectedTab === 'resolveMigrations'">
                <TaskList ref="finishedMigrations" :tasks="allResolvedMigrations" type="finished"  />
                <!-- Buttons for Finished tab -->
                <div class="col-md-12 text-center">
                  <span class="pull-left mt-2"
                  ><b>Page Number: </b> {{ pageNumber + 1 }}</span
                  >
                  <button
                      class="btn btn-link btn-sm btn-round"
                      :disabled="pageNumber === 0"
                      v-on:click="prevPage"
                  >
                    Prev
                  </button>
                  <button
                      class="btn btn-link btn-sm btn-round"
                      :disabled="allResolvedMigrations.length < page_Size"
                      v-on:click="nextPage"
                  >
                    Next
                  </button>

                  <button
                      class="btn btn-danger btn-sm pull-right"
                      v-on:click="refreshMigrations"
                  >
                    Clear
                  </button>
                </div>
              </div>
              <div id="abandonedMigrations" class="tab-pane fade" v-if="selectedTab === 'abandonedMigrations'">
                <TaskList :tasks="abandonedMigrations" type="abandoned" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <migration-notes-modal ref="notes" />
    <ticket-custom-message ref="ticketMessage" :presetMacros="presetMacros" :tab="selectedTab"/>
    <checklist-comments-modal ref="comment" />
    <update-checklist-modal :checklist="checklist" />
    <custom-status-modal ref="customStatus" />
    <account-modal ref="accountModal" />
    <preset-macros-modal :presetMacros="presetMacros" />
    <psi-modal ref="psiModal" />
    <temp-domain-modal ref="tempDomainModal" />
  </div>
</template>

<script>
import { db } from "@/firebase/init";
import logRocket from "../../../mixins/logRocket";
import _ from "lodash";
export default {
  mixins: [logRocket],
  name: "migrationTasks",
  components: {
    TaskList: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/MigrationsList.vue"
            ),
    ticketCustomMessage: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/ticketCustomMessage.vue"
            ),
    migrationNotesModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/migrationNotesModal.vue"
            ),
    checklistCommentsModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/checklistCommentsModal"
            ),
    updateChecklistModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/updateChecklistModal"
            ),
    accountModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/accountModal"
            ),
    customStatusModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/customStatusModal"
            ),
    presetMacrosModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/presetMacrosModal"
            ),
    psiModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/psiModal"
            ),
    tempDomainModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/showTempDomainModal"
            ),
  },
  data() {
    return {
      selectedTab: 'activeMigrations',
      selectedTabValues: [],
      allResolvedMigrations: [],
      // allReviewMigrations: [],
      checklist: [],
      presetMacros: [],
      pageNumber: 0,
      page_Size: 10,
      searchQuery: null,
      searchBy: 'domain',
    };
  },
  computed: {
    activeMigrations() {
      let new_array = this.$store.getters["tasks/getActiveMigrations"];
      new_array = new_array.sort(
          (a, b) => new Date(b.created) - new Date(a.created)
      );
      return new_array;
    },
    reviewMigrations() {
      let new_array = this.$store.getters["tasks/getReviewMigrations"];
      new_array = new_array.sort(
          (a, b) => new Date(a.created) - new Date(b.created)
      );
      return new_array;
    },
    abandonedMigrations() {
      return this.$store.getters["tasks/getAbandonedMigrations"];
    },

    last() {
      return this.allResolvedMigrations.length > 0
          ? this.allResolvedMigrations[this.allResolvedMigrations.length - 1]
          : null;
    },
    first() {
      return this.allResolvedMigrations.length > 0
          ? this.allResolvedMigrations[0]
          : null;
    },
  },
  watch: {
    page_Size () {
      this.getUpdatedData()
    }
  },
  async mounted() {
    if (localStorage.getItem("backUrl")) {
      localStorage.removeItem("backUrl");
    }
    const settings = await db
        .collection("permissions")
        .doc("migration-checklist")
        .get();
    this.checklist = settings.data().checklist;
    const macros = await db
        .collection("permissions")
        .doc("preset_macros")
        .get();
    this.presetMacros = macros.data().replies;
  },
  beforeDestroy() {
    this.$store.dispatch('tasks/resetReviewMigrationListener');
  },
  methods: {
    async switchTab(value){
      this.selectedTab = value
      await this.$store.dispatch("async/stateUpdate", {state: false});
      await this.$store.dispatch('tasks/resetReviewMigrationListener');
      switch (value) {
        case "reviewMigrations":
          await this.$store.dispatch('tasks/fetchReviewMigrationsTasks');
          setTimeout(() => {
            this.$store.dispatch("async/stateUpdate", {state: true});
          }, 800);
          return;
        case "resolveMigrations":
          await this.getUpdatedData();
          await this.$store.dispatch("async/stateUpdate", {state: true});
          return;
        case "abandonedMigrations":
          await this.$store.dispatch('tasks/fetchAbandonedMigrationsTasks');
          await this.$store.dispatch("async/stateUpdate", {state: true});
          return;
        default:
          break;
      }
      await this.$store.dispatch("async/stateUpdate", {state: true});
      console.log('i was called here')
      try {
        this.selectedTabValues.forEach(tab => {
          $(`#${tab}`).collapse('show')
        });
      } catch (e) {
        console.log('error occured here for collaspe', e.toString())
      }
    },
    async getUpdatedData() {
      console.log('im called')
      //getting data for finished component
      this.allResolvedMigrations = [];
      this.pageNumber = 0;
      await this.$store.dispatch("async/stateUpdate", {state: false});
      try {
        let ref = db
            .collection("savedMigrations")
            .where("status", "==", "finished");
        if (this.searchQuery && this.searchBy === 'email') {
          ref = ref.where('email', '==', this.searchQuery.toLowerCase())
        } else if (this.searchQuery && this.searchBy === 'domain') {
          ref = ref.where('siteDetails.domainName', '==', this.searchQuery.toLowerCase())
        }
        const docs = await ref.orderBy("created", "desc")
            .limit(this.page_Size)
            .get()
        docs.forEach((doc) => {
          this.allResolvedMigrations.push({docId: doc.id, ...doc.data()});
        });
        console.log(this.allResolvedMigrations, 'now')
        await this.$store.dispatch("async/stateUpdate", {state: true});
      } catch (e) {
        console.log(e)
        await this.$store.dispatch("async/stateUpdate", {state: true});
      }
    },
    refreshMigrations() {
      this.$refs.finishedMigrations.searchQuery = ''
      this.searchQuery = ''
      this.getUpdatedData();
    },
    async prevPage() {
      if (this.first) {
        this.pageNumber--;
        await this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          let ref = db
              .collection("savedMigrations")
              .where("status", "==", "finished");
          if (this.searchQuery && this.searchBy === 'email') {
            ref = ref.where('email', '==', this.searchQuery.toLowerCase())
          } else if (this.searchQuery && this.searchBy === 'domain') {
            ref = ref.where('siteDetails.domainName', '==', this.searchQuery.toLowerCase())
          }
          // if (this.searchQuery) {
          //   ref = ref.where('siteDetails.domainName' , '==', this.searchQuery)
          // }
          const docs = await ref
              .orderBy("created", "desc")
              .endBefore(this.first.created)
              .limitToLast(this.page_Size)
              .get()
          this.allResolvedMigrations = [];
          docs.forEach((doc) => {
            this.allResolvedMigrations.push({docId: doc.id, ...doc.data()});
          });
          console.log(this.allResolvedMigrations);
          await this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (e) {
          console.log(e.toString())
          await this.$store.dispatch("async/stateUpdate", {state: true});
        }
      }
    },
    async nextPage() {
      if (this.last) {
        this.pageNumber++;
        await this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          let ref = db
              .collection("savedMigrations")
              .where("status", "==", "finished");
          if (this.searchQuery && this.searchBy === 'email') {
            ref = ref.where('email', '==', this.searchQuery.toLowerCase())
          } else if (this.searchQuery && this.searchBy === 'domain') {
            ref = ref.where('siteDetails.domainName', '==', this.searchQuery.toLowerCase())
          }
          // if (this.searchQuery) {
          //   ref = ref.where('siteDetails.domainName' , '==', this.searchQuery)
          // }
          const docs = await ref
              .orderBy("created", "desc")
              .startAfter(this.last.created)
              .limit(this.page_Size)
              .get();
          this.allResolvedMigrations = [];
          docs.forEach((doc) => {
            this.allResolvedMigrations.push({docId: doc.id, ...doc.data()});
          });
          console.log(this.allResolvedMigrations);
          await this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (e) {
          console.log(e.toString())
          await this.$store.dispatch("async/stateUpdate", {state: true});
        }
      }
    },
  },
};
</script>

<style scoped>
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
</style>
